<template>
  <v-card class="trezo-card bg-white border-0 shadow-none border-radius mb-0">
    <div class="v-card-header">
      <h5 class="mb-0">Yanıt Derecelendirme Dağılımı</h5>
    </div>
    <div class="p-3">
      <div v-if="isEmpty" class="text-muted py-4 text-center">
        Henüz derecelendirme yok
      </div>
      <apexchart
        v-else
        type="donut"
        height="280"
        :options="chartOptions"
        :series="distribution.series[0]?.data ?? []"
      />
    </div>
  </v-card>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ApexOptions } from 'apexcharts'
import type { TimeSeries, KpiStat } from '@/services/adminStatsApi'

const props = defineProps<{
  distribution: TimeSeries
  avgRating: KpiStat
}>()

const isEmpty = computed(() =>
  !props.distribution.series[0]?.data.some(v => v > 0)
)

const chartOptions = computed<ApexOptions>(() => ({
  labels: props.distribution.labels,
  colors: ['#ef4444', '#f97316', '#f59e0b', '#84cc16', '#10b981'],
  legend: { position: 'bottom' },
  plotOptions: {
    pie: {
      donut: {
        labels: {
          show: true,
          total: {
            show: true,
            label: 'Ort. Puan',
            formatter: () =>
              props.avgRating.current !== null
                ? `${props.avgRating.current} ★`
                : '—',
          },
        },
      },
    },
  },
  dataLabels: { enabled: false },
  tooltip: { y: { formatter: (v: number) => `${v} değerlendirme` } },
}))
</script>
